import React, { useContext, useState, Fragment } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PermissionContext } from '../../hoc/withPermission';
import { ActionDropdown } from 'common';
import { API_HOST } from '../../consts';

const ClassConfirmationActions = (id) => {
  const [loading, setLoading] = useState(false);
  const { hasPermission } = useContext(PermissionContext);
  const actions = [];

  if (hasPermission('login.can_send_welcome_email')) {
    actions.push({
      value: 'confirmarTurma',
      label: 'Confirmar Turma',
    });
  }

  actions.push({
    value: 'cancelarTurma',
    label: 'Cancelar Turma',
  });

  const handleActionClick = (action) =>
    ({
      confirmarTurma() {
        setLoading(true);
        axios
          .post(`${API_HOST}/academico/status_confirmacao/${id.id}/confirm`)
          .then(() => {
            toast.success('Turma Confirmada com sucesso.');
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            const msg = error.response?.data[0] || "Ocorreu um erro.";
            toast.error(msg);
          });
      },
      cancelarTurma() {
        setLoading(true);
        axios
          .post(`${API_HOST}/academico/status_confirmacao/${id.id}/cancel`)
          .then(() => {
            toast.success('Turma Cancelada com sucesso.');
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            const errors = get(
              error,
              'response.data',
              'Ocorreu um erro inesperado.'
            );
            toast.error('Ocorreu um erro.');
          });
      },
    }[action]());

  return (
    actions.length > 0 && (
      <>
        <div>
          <ActionDropdown actions={actions} onClick={handleActionClick} />
          {loading && (
            <FontAwesomeIcon
              spin={loading}
              icon="spinner"
              style={{ marginLeft: 10 }}
            />
          )}
        </div>
      </>
    )
  );
};

export default ClassConfirmationActions;
